module.exports = __webpack_public_path__ + "img/speaker-Dudey-imgs.a87e5160.png";